<workspace-breadcrumb class="mb-4 md:mb-8 block" />

<div class="flex flex-col gap-6">
  @if (categoriesIsLoading()) {
    <korviu-loader />
  } @else {
    <app-category-carousel
      [categories]="categories()"
      [fitCategories]="true"
      [selectedCategoryId]="selectedCategoryId()"
      (categorySelected)="onCategoryClick($event)"
    />
  }

  <korviu-list [config]="brandListConfig" #brandList />
</div>
